export default "__VITE_ASSET__CKaSddK3__"